import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Canvas } from "@react-three/fiber";
import { getDemoUrl } from "../../Components/utils/format-utils";
import { Demo } from "../../Components/Demo";
import { Header } from "../Headers";
import { Footer } from "../Footer";

export const Characters = () => {
  const { name } = useParams();
  const [isLoaded, setIsLoaded] = useState(false);
  const [hideLoading, setHideLoading] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      const timer = setTimeout(() => {
        setHideLoading(true); // 延迟 3 秒后隐藏 loading 页面
      }, 2000);
      return () => clearTimeout(timer); // 清理定时器
    }
  }, [isLoaded]);

  return (
    <div className={"characters"}>
      {!hideLoading && (
        <div className="loading-demo">
          <h2>Loading {name?.toUpperCase()}</h2>
        </div>
      )}
      <Header />
      <Canvas style={{ zIndex: 0 }}>
        <Demo
          role={name?.toLowerCase() || ""}
          url={getDemoUrl(name?.toLowerCase() || "trainee")}
          setIsLoaded={setIsLoaded}
        />
      </Canvas>
      <Footer />
    </div>
  );
};
